import {Col, Row} from "reactstrap";

const Header = ({title, count}) => (
    <Row className="mb-5">
        <Col>
            <div className="display-4">
                {title}
                {count ? <span className="ml-1">({count})</span> : null}
            </div>
        </Col>
    </Row>
);

export default Header;